import script from "./template2.vue?vue&type=script&setup=true&lang=js"
export * from "./template2.vue?vue&type=script&setup=true&lang=js"

import "./template2.vue?vue&type=style&index=0&id=452dce40&lang=less"

const __exports__ = script;

export default __exports__